import { createSlice } from "@reduxjs/toolkit";

import { Modal } from "../../../../../services";
import { ReduxReducer } from "../../../../interface";
import { GlobalState } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	request: {
		clients: [],
	},
};

const setRequestClients: ReduxReducer<
	State,
	Modal.ModelSimpleForMultySelectModalClient[]
> = (state, action) => {
	state.request.clients = action.payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const globalStateMultySelectModalsData = createSlice({
	name: GlobalState.ConstantGlobalStateSlice.MULTY_SELECT_MODALS_DATA,
	initialState,
	reducers: {
		reset,
		setRequestClients,
	},
});

export const globalStateMultySelectModalsDataAction =
	globalStateMultySelectModalsData.actions;
export const globalStateMultySelectModalsDataReducer =
	globalStateMultySelectModalsData.reducer;
export type globalStateMultySelectModalsDataState = State;

export default globalStateMultySelectModalsData;
